import api from './api';

// Listar modelos de fichas de orçamento
export const getBudgetSheetModels = async () => {
  const response = await api.get('/budget-sheets/models');
  return response.data;
};

// Listar fichas de um levantamento
export const getSurveyBudgetSheets = async (surveyId) => {
  const response = await api.get(`/budget-sheets/surveys/${surveyId}`);
  return response.data;
};

// Obter ficha específica
export const getBudgetSheet = async (id) => {
  const response = await api.get(`/budget-sheets/${id}`);
  return response.data;
};

// Criar ficha de orçamento
export const createBudgetSheet = async (surveyId, data) => {
  const response = await api.post(`/budget-sheets/surveys/${surveyId}`, data);
  return response.data;
};

// Atualizar ficha de orçamento
export const updateBudgetSheet = async (id, data) => {
  const response = await api.put(`/budget-sheets/${id}`, data);
  return response.data;
};

// Salvar ficha (criar ou atualizar)
export const saveBudgetSheet = async (surveyId, data) => {
  if (data.id) {
    return updateBudgetSheet(data.id, data);
  }
  return createBudgetSheet(surveyId, data);
};

// Deletar ficha
export const deleteBudgetSheet = async (surveyId, id) => {
  const response = await api.delete(`/surveys/${surveyId}/budget-sheets/${id}`);
  return response.data;
};

// Obter configuração de precificação
export const getPricingConfig = async () => {
  const response = await api.get('/budget-sheets/pricing-config');
  return response.data;
};

// Calcular precificação
export const calculatePricing = async (surveyId, budgetSheetId, data) => {
  const response = await api.post(`/surveys/${surveyId}/budget-sheets/${budgetSheetId}/calculate-pricing`, data);
  return response.data;
};

// Consumíveis
export const getConsumables = async (surveyId, budgetSheetId) => {
  const response = await api.get(`/surveys/${surveyId}/budget-sheets/${budgetSheetId}/consumables`);
  return response.data;
};

export const addConsumable = async (surveyId, budgetSheetId, data) => {
  const response = await api.post(`/surveys/${surveyId}/budget-sheets/${budgetSheetId}/consumables`, data);
  return response.data;
};

export const removeConsumable = async (surveyId, budgetSheetId, consumableId) => {
  const response = await api.delete(`/surveys/${surveyId}/budget-sheets/${budgetSheetId}/consumables/${consumableId}`);
  return response.data;
};

// Upload PDF de cortes
export const uploadCortesPdf = async (surveyId, budgetSheetId, file) => {
  const formData = new FormData();
  formData.append('file', file);
  const response = await api.post(`/surveys/${surveyId}/budget-sheets/${budgetSheetId}/upload-cortes`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  });
  return response.data;
};

// Obter PDF de cortes
export const getCortesPdf = async (surveyId, budgetSheetId) => {
  const response = await api.get(`/surveys/${surveyId}/budget-sheets/${budgetSheetId}/cortes-pdf`);
  return response.data;
};

export default {
  getBudgetSheetModels,
  getSurveyBudgetSheets,
  getBudgetSheet,
  createBudgetSheet,
  updateBudgetSheet,
  saveBudgetSheet,
  deleteBudgetSheet,
  getPricingConfig,
  calculatePricing,
  getConsumables,
  addConsumable,
  removeConsumable,
  uploadCortesPdf,
  getCortesPdf,
  getBudgetSheetItems: async (budgetSheetId) => {
    const response = await api.get(`/budget-sheet-items/${budgetSheetId}`);
    return response.data;
  }
};
